export default {
      id: "ic_system_phone-usage",
      viewBox: "0 0 9 15",
      url: "/" + "images/icons.3.109.2.svg#ic_system_phone-usage",
      toString: function () {
        return this.url;
      }
    }